module.exports = __webpack_public_path__ + "static/media/fan_rotating.6ecb5952.gif";